
<div class="watermark" *ngIf="env.DEMO != ''">{{env.DEMO}}</div>
<div class="demo-banner" *ngIf="env.DEMO != ''">
  <div class="scroll-text">
    ⚠️ {{env.DEMO}} - This environment is for demonstration purposes only. Data shown is not real and may be reset at any time.
  </div>
</div>
<div class="displayflex">
  <div class="width50 imgcontainer">
    <img class="fullwidth" src="../assets/images/2025UICloudBite.jpg" />
  </div>
  <div class="width50 displayflex pagecontainer" >

    <span class="row-container spacing eposmanagerposition"  [class.banner]="env.DEMO != ''">
      <!-- <span class="epostext">&nbsp;ePos</span>
      <span class="managertext">&nbsp;Manager</span> -->
    </span>

    <div class="justifycenter">
      <form class="form aligncenter">
        <div class="col-sm-8 hellocontainer text-center justify-content-center">
          <div class="mb-4">
            <img class="eposmanagerlogo" src="/assets/images/qas-logo.png" />
          </div>
          <span class="hellotext">Hello! Let's get started</span>
          <span class="signintext">Sign in to continue.</span>
        </div>
        <div class="mat-small alert alert-danger col-sm-8" [@slideInOut]="errorDisplay">
          {{errorMsg}}
        </div>

        <div class="form-group col-sm-8 pl-0 mt-10">
          <label class="labeltext">Username</label>
          <input appBlockQuotes type="text" id="homePageEmail" name="homePageEmail" class="form-control customformcontrol" [ngModelOptions]="{standalone: true}" [(ngModel)]="userIdInput" [disabled]="loading">
        </div>
        <div class="form-group col-sm-8 pl-0 flex flex-column">
          <label class="labeltext" for="password">Password</label>
          <p-password [(ngModel)]="passwordInput" (keydown.enter)="login()" [ngModelOptions]="{standalone: true}" styleClass="w-full" inputStyleClass="w-full" [toggleMask]="true" [feedback]="false"></p-password>
          <!-- <div class="input-group customformcontrol p-0">
            <input appBlockQuotes type="{{ hidePass ? 'password' : 'text' }}" class="form-control  hide-border-right" id="homePagePassword" name="homePagePassword"
              [(ngModel)]="passwordInput" (keydown.enter)="login()" [disabled]="loading">
            <div class="input-group-append">
              <span class="input-group-text passwordiconcontainer hide-border-left backgroundwhite" [class.disabled]="loading"
                (click)="toggleRevealPassword()">
                <mat-icon>{{hidePass ? 'visibility_off' : 'visibility'}}</mat-icon>
              </span>
            </div>
          </div> -->
        </div>
        <div class="form-group col-sm-8 pl-0">
          <button mat-flat-button [class.spinner]="loading" [disabled]="loading" type="button" (click)="login()"
            id="loginButton" color="primary">
            <span *ngIf="!loading">Login</span> 
            <i class="pi pi-spin pi-spinner py-1" *ngIf="loading" style="font-size: 1.5rem; color: white; "></i>
          </button>
        </div>
      </form>
    </div>
    
    <div class="footertext">
      <img class="poweredlogo" src="/assets/images/powered-by.png" />
      <app-footer></app-footer>
    </div>
  </div>
</div>